import { reactive } from 'vue';

const state = reactive({
  currentLocale: 'et',
  messages: {}
});

export default {
  state,

  async loadLocale(locale) {
    if (state.messages[locale]) return;

    try {
      const messages = await import(`./locales/${locale}.json`);
      state.messages[locale] = messages.default;
    } catch (error) {
      console.error(`Error loading locale ${locale}:`, error);
    }
  },

  setLocale(locale) {
    state.currentLocale = locale; // now reactive
  },

  translate(key) {
    const keys = key.split('.');
    let value = state.messages[state.currentLocale];

    for (const part of keys) {
      if (value && typeof value === 'object' && part in value) {
        value = value[part];
      } else {
        return key;
      }
    }
    return value;
  }
};
